import { render, staticRenderFns } from "./VisitorRecords.vue?vue&type=template&id=748dfc2c&scoped=true&"
import script from "./VisitorRecords.vue?vue&type=script&lang=js&"
export * from "./VisitorRecords.vue?vue&type=script&lang=js&"
import style0 from "./VisitorRecords.vue?vue&type=style&index=0&id=748dfc2c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748dfc2c",
  null
  
)

export default component.exports